module.exports = __webpack_public_path__ + "media/images/application/template/download-d76fbb47fc3926d9630878254dbb5e5b.svg";